import { useEffect, useState } from 'react';
import logo from "../../assets/logo/fetchjobLogo.png";
import { Link, useNavigate } from 'react-router-dom';
import classes from './styles/searchNavbarCircular.module.css';

import { getSubCategory } from '../../services/Static';
import menuIcon from "../../assets/icons/search.png";

const hemburgerIcon = "https://cdn-icons-png.flaticon.com/128/12314/12314153.png"

const SearchNavbarCircular = () => {
    const [mobileMenu, setMobileMenu] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [isSuggestion, setIsSuggestion] = useState(false);
    const [type, setType] = useState("United States");
    const navigate = useNavigate();

    const handleMouseEnter = () => setIsOpen(true);
    const closeDropdown = () => setIsOpen(false);

    const [allKeywords, setAllKeywords] = useState([]);


    const handleSearchInputChange = (e) => {
        e.preventDefault();
        setSearchTerm(e.target.value);
        setIsSuggestion(true)
      };
    
      const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          handleSearchInputClick(searchTerm)
        }
      };
    
      const handleSearchInputClick = (word) => {
        const slug = word.toLowerCase().replace(/\s+/g, '-');
        if(type === "India"){
          navigate(`/remote-jobs-india/${slug}`)
        }else if(type === "Germany"){
          navigate(`/remote-jobs-germany/${slug}`)
        }else if(type === "United Kingdom"){
          navigate(`/remote-jobs-uk/${slug}`)
        }else if(type === "France"){
          navigate(`/remote-jobs-france/${slug}`)
        }else if(type === "Australia"){
          navigate(`/remote-jobs-australia/${slug}`)
        }else{
          navigate(`/remote-jobs-usa/${slug}`)
        }
        setSearchTerm(word);
        setIsSuggestion(false);
      };

      useEffect(() => {
        const fetchAllSubcategory = async () => {
          try{
            const data = await getSubCategory();
            setAllKeywords(data);
          }catch(err){
            console.log("error ", err);
          }
        }
        fetchAllSubcategory();
      },[])
    
      const filterSuggestedKeyword = (searchTerm) => {
        console.log("Search Term ", searchTerm);
        return allKeywords?.filter(
          (word) =>
            word.SubCategoryName.toLowerCase().startsWith(searchTerm.toLowerCase())
        );
      };

      useEffect(() => {
          const fetchCountry = async () => {
            try{
              const response = await fetch("https://get.geojs.io/v1/ip/geo.json");
              const data = await response.json();
              if(data.country === "India"){
                setType("India");
              }else if(data.country === "United Kingdom"){
                setType("United Kingdom");
              }else if(data.country === "Canada"){
                setType("Canada");
              }else if(data.country === "Germany"){
                setType("Germany");
              }else if(data.country === "France"){
                setType("France");
              }else if(data.country === "Australia"){
                setType("Australia");
              }else{
                setType("United States");
              }
            } catch{
              console.log("Error in IP to Country API");
            }
          }
          fetchCountry();
          }, []);


  return (
      <>
        <div className={classes.container}>
            <div className={classes.innerContainer}>
                <Link to="/"><div className={classes.logoCon}><img src={logo} alt="logo"/></div></Link>
                <div className={classes.buttonsCon}>
                    <div className={classes.searchCon}>
                      <img src={menuIcon} alt='Find remote jobs' className={classes.searchIcon}/>
                        <input
                        placeholder="Enter job title..."
                        value={searchTerm}
                        onChange={(e) => handleSearchInputChange(e)}
                        onKeyDown={handleKeyDown}
                        className={classes.searchInput}
                        />
                        
                        {searchTerm && isSuggestion && <div className={classes.suggestCon}>
                        {filterSuggestedKeyword(searchTerm).map((item,i) => {
                        return <div key={i} >
                            <p className={classes.suggestedKeyword} onClick={() => {handleSearchInputClick(item.SubCategoryName); console.log(item.SubCategoryName)}}>{item.SubCategoryName}</p>
                        </div>})}
                        <div key={"keyword"} >
                            <p className={classes.suggestedKeyword} onClick={() => {handleSearchInputClick(searchTerm)}}>{searchTerm}</p>
                        </div>
                        </div>}

                        <div className={classes.dropdown} onMouseEnter={handleMouseEnter} onMouseLeave={closeDropdown}>
                        <button
                            className={classes.dropdownButton}
                            aria-expanded={isOpen}
                        >
                            {type} <img src={"https://cdn-icons-png.flaticon.com/128/8567/8567254.png"} alt='remote Jobs'/>
                        </button>
                        {isOpen && (
                            <div className={classes.dropdownMenu}>
                                <Link to="/remote-jobs-usa" onClick={() => setType("United States")}>United States</Link>
                                <Link to="/remote-jobs-uk" onClick={() => setType("United Kingdom")}>United Kingdom</Link>
                                <Link to="/remote-jobs-germany" onClick={() => setType("Germany")}>Germany</Link>
                                <Link to="/remote-jobs-france" onClick={() => setType("France")}>France</Link>
                                <Link to="/remote-jobs-australia" onClick={() => setType("Australia")}>Australia</Link>
                                <Link to="/remote-jobs-india" onClick={() => setType("India")}>India</Link>
                            </div>
                        )}
                        </div>
                    </div>
                    <>
                    <Link to="/" className={classes.button}>Home</Link>
                    <Link to="/about" className={classes.button}>About</Link>
                    <Link to="/contact" className={classes.button}>Contact</Link>
                    <Link to="/career" className={classes.button}>Career</Link>
                    <Link to="/blog" className={classes.button}>Blog</Link>
                    </>
                </div>

                {/* Hamburger icon (mobile) */}
          <div
            className={classes.hamburger}
            onClick={() => setMobileMenu(!mobileMenu)}
          >
            <img src={hemburgerIcon} alt="menu" />
          </div>
            </div>
        </div>

        {mobileMenu && (
        <div className={classes.mobileMenu}>
          <Link onClick={() => setMobileMenu(false)} to="/">Home</Link>
          <Link onClick={() => setMobileMenu(false)} to="/about">About</Link>
          <Link onClick={() => setMobileMenu(false)} to="/contact">Contact</Link>
          <Link onClick={() => setMobileMenu(false)} to="/career">Career</Link>
          <Link onClick={() => setMobileMenu(false)} to="/blog">Blog</Link>
        </div>
      )}

        <div className={classes.mobileSearchCon}>
                      <img src={menuIcon} alt='Find remote jobs' className={classes.searchIcon}/>
                        <input
                        placeholder="Enter job title..."
                        value={searchTerm}
                        onChange={(e) => handleSearchInputChange(e)}
                        onKeyDown={handleKeyDown}
                        className={classes.searchInput}
                        />
                        
                        {searchTerm && isSuggestion && <div className={classes.suggestCon}>
                        {filterSuggestedKeyword(searchTerm).map((item,i) => {
                        return <div key={i} >
                            <p className={classes.suggestedKeyword} onClick={() => {handleSearchInputClick(item.SubCategoryName); console.log(item.SubCategoryName)}}>{item.SubCategoryName}</p>
                        </div>})}
                        <div key={"keyword"} >
                            <p className={classes.suggestedKeyword} onClick={() => {handleSearchInputClick(searchTerm)}}>{searchTerm}</p>
                        </div>
                        </div>}

                        <div className={classes.dropdown} onMouseEnter={handleMouseEnter} onMouseLeave={closeDropdown}>
                        <button
                            className={classes.dropdownButton}
                            aria-expanded={isOpen}
                        >
                            {type} <img src={"https://cdn-icons-png.flaticon.com/128/8567/8567254.png"} alt='remote Jobs'/>
                        </button>
                        {isOpen && (
                            <div className={classes.dropdownMenu}>
                                <Link to="/remote-jobs-usa" onClick={() => setType("United States")}>United States</Link>
                                <Link to="/remote-jobs-germany" onClick={() => setType("Germany")}>Germany</Link>
                                <Link to="/remote-jobs-uk" onClick={() => setType("United Kingdom")}>United Kingdom</Link>
                                <Link to="/remote-jobs-france" onClick={() => setType("France")}>France</Link>
                                <Link to="/remote-jobs-australia" onClick={() => setType("Australia")}>Australia</Link>
                                <Link to="/remote-jobs-india" onClick={() => setType("India")}>India</Link>
                            </div>
                        )}
                        </div>
                    </div>
        </>
  )
}

export default SearchNavbarCircular;
